import { Form } from 'factorial-form'
import _ from 'lodash'

class SupplementObservationForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      id: 'number',
      supplement_id: 'number',
      text: 'string',
    })
  }

  get supplementObservationData(): Record<string, any> {
    const data = this.data()
    const attrs = _.pick(data, ['text', 'id', 'supplement_id'])

    return { ...attrs }
  }
}

export default SupplementObservationForm
